import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import SponsorForm from '../../components/advertisement/sponsorForm'
import firebase from '../../config/firebase'

const NewSponsor = () => {
  const firebaseKey = firebase
    .database()
    .ref()
    .child('sponsors')
    .push().key

  return (
    <div>
      <Segment color="black">
        <Header size="large"> New Sponsor </Header>
        <SponsorForm firebaseKey={firebaseKey} action="New" />
      </Segment>
    </div>
  )
}

export default NewSponsor



// WEBPACK FOOTER //
// ./src/containers/advertisement/newSponsor.js